(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('BrokerageLocationDetailController', BrokerageLocationDetailController);

    BrokerageLocationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'BrokerageLocation', 'BrokerageRegion', 'Address'];

    function BrokerageLocationDetailController($scope, $rootScope, $stateParams, entity, BrokerageLocation, BrokerageRegion, Address) {
        var vm = this;

        vm.brokerageLocation = entity;

        var unsubscribe = $rootScope.$on('valueconnectApp:brokerageLocationUpdate', function(event, result) {
            vm.brokerageLocation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
